import React from 'react';
import { Section, Divider } from 'rebass';

import PageHelmet from 'frontend/components/PageHelmet';

import CharacterInputPanel from './CharacterInputPanel';
import SimcWarning from './SimcWarning';
import SubmitSimulationButton from './SubmitSimulationButton';
import ItemChooser from './ItemChooser';
import RawSimcInput from './RawSimcInput';
import AdvancedSimOptions from './AdvancedSimOptions';
import CustomAplOptions from './CustomAplOptions';
import ReportOptions from './ReportOptions';

const GearCompare = () => (
  <div>
    <PageHelmet page="gear" />
    <Section pt={2} px={1}>
      <CharacterInputPanel />

      <Divider my={2} />

      <ItemChooser />

      <Divider my={2} />

      <AdvancedSimOptions />

      <Divider my={2} />

      <CustomAplOptions type="gear" />

      <Divider my={2} />

      <ReportOptions type="gear" />

      <Divider my={2} />

      <RawSimcInput type="gear" />

      <SubmitSimulationButton type="gear" />

      <SimcWarning />
    </Section>
  </div>
);

export default GearCompare;
